import { useCallback } from 'react';
import { isNativeApp } from '../utils/utils';

/**
 * Custom hook for camera capture functionality
 * 
 * @param {Object} config - Camera configuration
 * @param {string} config.workOrderNumber
 * @param {string} config.vin
 * @returns {Object} Hook interface with camera functions
 */
export const useCameraCapture = ({ workOrderNumber, vin }) => {
  const handleCapturePhoto = useCallback((damageId, title, category = "DAMAGE") => {
    if (isNativeApp()) {
      window.NativeApp.capturePhoto(
        workOrderNumber,
        vin,
        damageId,
        category,
        title
      );
    } else {
      console.log("camera not available in web view.");
    }
  }, [workOrderNumber, vin]);

  return { handleCapturePhoto };
};